/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 *
 * @flow
 */

import React from 'react';
import classes from './Container.module.css';

const Container = ({ children, style }) => {
  return (
    <div className={[classes.container, style].join(' ')}>{children}</div>
  );
}
export default Container;
